/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the GenderAndEmailAddressDetails
 *
 * @class GenderAndEmailAddressDetails
 */
class GenderAndEmailAddressDetails {
  /**
   * Creates an instance of GenderAndEmailAddressDetails.
   * @param {*} json
   * @memberof GenderAndEmailAddressDetails
   */
  constructor(json = null) {
    if (json) {
      // string
      this.gender = json.gender;

      // string
      this.emailAddress = json.emailAddress;

      // string
      this.dateOfBirth = json.dateOfBirth;
    }
  }
}

/**
 * Models the NewACESModifyEmailAddressDetails
 *
 * @class NewACESModifyEmailAddressDetails
 */
class NewACESModifyEmailAddressDetails {
  /**
   * Creates an instance of NewACESModifyEmailAddressDetails.
   * @param {*} json
   * @memberof NewACESModifyEmailAddressDetails
   */
  constructor(json = null) {
    if (json) {
      // string
      this.concernRoleID = json.concernRoleID;

      // string
      this.email = json.email;

      // string
      this.domainNameCE = json.domainNameCE;
    }
  }
}

/**
 * Models the NewACESModifyEmailAddressRespDtlsResponse
 *
 * @class NewACESModifyEmailAddressRespDtlsResponse
 */
class NewACESModifyEmailAddressRespDtlsResponse {
  /**
   * Creates an instance of NewACESModifyEmailAddressRespDtlsResponse.
   * @param {*} json
   * @memberof NewACESModifyEmailAddressRespDtlsResponse
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.isEmailModified = json.isEmailModified;
    }
  }
}

export default {
  GenderAndEmailAddressDetails,

  NewACESModifyEmailAddressDetails,

  NewACESModifyEmailAddressRespDtlsResponse,
};
